const Page = () => <>404</>;

export default Page;
